import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Regionalization from '../services/regionalization';
import { bindProfile, unbindProfile } from 'actions/profileActions';
import {
  bindActiveSession,
  unbindActiveSession,
  setActiveSession,
  completeLevelAndExit, completeLevelPreview
} from 'actions/activeSessionActions';
import { archiveSession } from 'actions/sessionActions';
import NavBar from 'views/navBar';
import Footer from 'views/footer';
import { i18n } from 'helpers/i18n'

const changeTempPasswordUrl = '/changeTempPassword';

const isIE = false || !!document.documentMode;

class App extends Component {

  static propTypes = {
    children: PropTypes.element.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired
    }).isRequired,
    auth: PropTypes.shape({
      loggedIn: PropTypes.bool.isRequired,
      authData: PropTypes.shape({
        uid: PropTypes.string
      })
    }).isRequired,
    profile: PropTypes.object.isRequired,
    activeSession: PropTypes.string,
    bindProfile: PropTypes.func.isRequired,
    unbindProfile: PropTypes.func.isRequired,
    bindActiveSession: PropTypes.func.isRequired,
    unbindActiveSession: PropTypes.func.isRequired,
    archiveSession: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired
  }

  static contextTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired
  }

  static childContextTypes = {
    setActiveSession: PropTypes.func,
    completeLevelAndExit: PropTypes.func,
    completeLevelPreview: PropTypes.func,
    auth: PropTypes.object,
    userId: PropTypes.string,
    profile: PropTypes.object,
    staff: PropTypes.bool,
    archiveSession: PropTypes.func,
    regionData: PropTypes.object,
    i18n: PropTypes.func
  }

  constructor (props) {
    super(props);
    this.boundProfileRefs = [];
    this.boundActiveSessionRefs = [];
  }

  getChildContext () {
    const {
      profile,
      auth,
      archiveSession: archive
    } = this.props;
    const { staff } = profile;
    let userId = null;
    if (auth && auth.authData && auth.authData.uid) {
      userId = auth.authData.uid;
    }
    const regionData = Regionalization.getRegionDataFromProfile(profile);
    return {
      setActiveSession: ::this.dispatchSetActiveSession,
      completeLevelAndExit: ::this.dispatchCompleteLevelAndExit,
      completeLevelPreview: ::this.dispatchCompleteLevelPreview,
      auth,
      userId,
      profile,
      regionData,
      staff,
      archiveSession: archive,
      i18n: i18n('en')
    };
  }

  componentDidMount () {
    this.bindProfile(this.props, true);
  }

  componentWillReceiveProps (nextProps) {
    const { history } = this.context;
    const { query } = this.context.location;
    const { auth: currentAuth } = this.props;
    const {
      auth: nextAuth,
      location: nextLocation,
      activeSession: nextActiveSession
    } = nextProps;

    if ((currentAuth && currentAuth.loggedIn) &&
        (!nextAuth || !nextAuth.loggedIn)) {
      this.unbindProfile();
    }
    if ((!currentAuth || !currentAuth.loggedIn) &&
        (nextAuth && nextAuth.loggedIn)) {
      this.bindProfile(nextProps, true);
    }

    const { authData } = nextAuth;
    if (
      authData &&
      authData.password &&
      authData.password.isTemporaryPassword &&
      nextLocation &&
      nextLocation.pathname !== changeTempPasswordUrl
    ) {
      history.replaceState( null, changeTempPasswordUrl, query);
      return;
    }

    if (nextActiveSession && nextActiveSession !== 'none' && nextLocation) {
      const { pathname } = nextLocation;
      const classUrl = `/class/${nextActiveSession}/`;
      if (!pathname.match(new RegExp(`^${classUrl}`))) {
        history.replaceState( null, classUrl );
      }
    } else if ((nextActiveSession === 'none' || nextActiveSession === '') && nextLocation) {
      const { pathname } = nextLocation;
      const classUrl = '/class/';
      if (pathname.match(new RegExp(`^${classUrl}`))) {
        history.replaceState( null, '/' );
      }
    }
  }

  componentWillUnmount () {
    this.unbindProfile();
  }

  bindProfile (props, pageLoad) {
    const { auth } = props;
    if (auth && auth.authData && auth.authData.uid) {
      const userId = auth.authData.uid;
      this.props.bindProfile(userId, this.boundProfileRefs);
      this.props.bindActiveSession(userId, this.boundActiveSessionRefs, pageLoad);
    }
  }

  unbindProfile () {
    this.props.unbindProfile(this.boundProfileRefs);
    this.props.unbindActiveSession(this.boundActiveSessionRefs);
  }

  dispatchSetActiveSession (sessionId, level, programId) {
    const { auth, dispatch } = this.props;
    if (auth && auth.authData && auth.authData.uid) {
      const userId = auth.authData.uid;
      const deviceRole = localStorage.getItem('deviceRole') || 'classroomDisplay';
      return dispatch(setActiveSession({ userId, sessionId, level, deviceRole, programId }));
    }
  }

  dispatchCompleteLevelAndExit ({ sessionId, programId, completedLevel, finished, contractId, funding, previousCompletedLevel }) {
    const { auth, dispatch } = this.props;
    if (auth && auth.authData && auth.authData.uid) {
      const userId = auth.authData.uid;
      return dispatch(completeLevelAndExit({
        userId,
        sessionId,
        programId,
        completedLevel,
        finished,
        contractId,
        funding,
        previousCompletedLevel
      }));
    }
  }

  dispatchCompleteLevelPreview ({ sessionId, programId, completedLevel, contractId, funding }) {
    const { auth, dispatch } = this.props;
    if (auth && auth.authData && auth.authData.uid) {
      const userId = auth.authData.uid;
      return dispatch(completeLevelPreview({
        userId,
        sessionId,
        programId,
        completedLevel,
        contractId,
        funding
      }))
    }
  }

  render () {
    const { auth, profile, location } = this.props;
    const { pathname } = location;
    const isHome = (pathname === '/');
    const logoutOnly = (pathname === changeTempPasswordUrl);

    return (
      <div>
        { !!isIE &&
          <div className="browser-warning">Internet Explorer is not fully supported yet. Please use Edge, Chrome, or Firefox for the best experience!</div>
        }
        {!pathname.match(/\/content/) &&
          <NavBar
              auth={auth}
              profile={profile}
              isHome={isHome}
              logoutOnly={logoutOnly} />
        }
        <div className="container">
          {this.props.children}
        </div>
        {!pathname.match(/\/content/) &&
          <Footer />
        }
      </div>
    );
  }

}

export default connect(
  state => {
    const { auth, profile, activeSession } = state;
    return { auth: { ...auth }, profile, activeSession };
  },
  (dispatch) => ({
    bindProfile: bindActionCreators(bindProfile, dispatch),
    unbindProfile: bindActionCreators(unbindProfile, dispatch),
    bindActiveSession: bindActionCreators(bindActiveSession, dispatch),
    unbindActiveSession: bindActionCreators(unbindActiveSession, dispatch),
    archiveSession: bindActionCreators(archiveSession, dispatch),
    dispatch
  })
)(App);



// WEBPACK FOOTER //
// ./src/views/app.jsx